"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LiveViewPanel = void 0;
var _styles = require("@material-ui/core/styles");
var _pittaDesignSystem = require("@thingsw/pitta-design-system");
var _clsx10 = _interopRequireDefault(require("clsx"));
var _react = _interopRequireWildcard(require("react"));
var _Drawer = _interopRequireDefault(require("@material-ui/core/Drawer"));
var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));
var _Check = _interopRequireDefault(require("@material-ui/icons/Check"));
var _Switch = _interopRequireDefault(require("@material-ui/core/Switch"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));
var _Input = _interopRequireDefault(require("@thingsw/pitta-design-system/dist/components/Input"));
var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));
var _lodash = _interopRequireDefault(require("lodash"));
var _RadioGroup = _interopRequireDefault(require("@material-ui/core/RadioGroup"));
var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));
var _immutabilityHelper = _interopRequireDefault(require("immutability-helper"));
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _reactRouterDom = require("react-router-dom");
var _pittaModules = require("@thingsw/pitta-modules");
var _useQuery = require("../hooks/useQuery");
var _detectBrowser = require("detect-browser");
var _LiveViewPlayer = require("./LiveViewPlayer");
var _moment = _interopRequireDefault(require("moment"));
var _LiveViewExceedModal = require("./LiveViewExceedModal");
var _withStyleProvider = require("../hoc/withStyleProvider");
var _MapboxLocationMap = require("./MapboxLocationMap");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // import { LiveViewPlayer } from "./LiveViewPlayer";
var StyledSwitch = (0, _styles.withStyles)(function () {
  return {
    root: {
      width: 48,
      height: 30,
      padding: 4
    },
    switchBase: {
      padding: 6,
      "&.Mui-checked": {
        transform: "translateX(18px)"
      }
    },
    thumb: {
      width: 18,
      height: 18
    },
    track: {
      backgroundColor: _pittaModules.LightColors.primary["2"],
      borderRadius: 11
    },
    colorPrimary: {
      "&.Mui-checked": {
        color: _pittaModules.LightColors.primary["0"]
      },
      "&.Mui-checked + .liveview-module-MuiSwitch-track": {
        backgroundColor: _pittaModules.LightColors.primary["7"],
        opacity: "1 !important" // mantis - 13824 Multi View 버튼 활성화 색상 수정 (2024.05.21 hongcs)
      }
    }
  };
})(_Switch["default"]);
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: _defineProperty({
      // padding: theme.spacing(3, 0, 0),
      padding: function padding(props) {
        if (props.app) {
          return 0;
        }
        if (props.notification || props.noMargin) {
          return 0;
        }
        return theme.spacing(3, 0, 0);
      },
      display: "flex",
      flexDirection: "column",
      flex: 1
    }, theme.breakpoints.up(_pittaModules.Webviewer.mobile), {
      margin: function margin(props) {
        if (props.noMargin) {
          return "0px !important";
        }
        return theme.spacing(0, 4, 2, 4);
      }
    }),
    menuDiv: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: _pittaModules.LightColors.primary["1"],
      color: _pittaModules.LightColors.primary["0"],
      padding: theme.spacing(1.125, 1),
      // "& svg": {
      //   fill: LightColors.primary["0"],
      // },
      borderBottom: "1px solid ".concat(_pittaModules.LightColors.primary["0"])
    },
    dirDiv: _defineProperty({
      display: "flex",
      alignItems: "center",
      // width: 62,
      cursor: "pointer"
    }, theme.breakpoints.up(_pittaModules.Webviewer.mobile), {
      marginRight: 5.5
    }),
    mapDiv: {
      // mantis - 9260, safari / chrome 지도안보이는 이슈 수정 (Leehj)
      height: 188,
      minHeight: 188,
      position: "relative",
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(2),
      flex: "1 1 auto"
    },
    // mantis - 9108, notification -> liveView버튼을 통해 열리는 모달 내의 지도 높이 수정(Leehj)
    mapDivNotification: _defineProperty({
      height: 259
    }, theme.breakpoints.up(_pittaModules.Webviewer.mobile), {
      height: 444
    }),
    mapDivMapBox: _defineProperty({
      marginTop: 0,
      marginBottom: 0,
      height: "calc(100vh - 84vw)"
    }, theme.breakpoints.up(_pittaModules.Webviewer.mobile), {
      height: 400
    }),
    mapDivApp: {
      // app에서 스크롤 생겨서 지도크기 조절 (HJ)
      height: "calc(100vh - 122vw)",
      marginTop: theme.spacing(1)
    },
    mapDivAppNoBottom: {
      marginBottom: 0
    },
    uncheckedMenu: {
      paddingLeft: 44
    },
    multiViewTextDiv: {
      marginLeft: theme.spacing(3),
      marginRight: theme.spacing(1)
    },
    liveViewDiv: {
      cursor: "pointer",
      width: "calc(50% - 0.5px)",
      "&:nth-child(odd)": {
        marginRight: 1
      },
      marginBottom: 1
    },
    selectedLiveviewDiv: {
      border: "3px solid ".concat(_pittaModules.LightColors.secondary["17"])
    },
    sLiveViewDiv: {
      width: "100%",
      margin: "0!important"
    },
    multiViewDiv: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between"
    },
    cameraDrawerDiv: {
      width: 469,
      height: "100%",
      display: "flex",
      flexDirection: "column"
    },
    iconBtn: {
      padding: 0
    },
    drawerHeaderDiv: {
      padding: theme.spacing(2),
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      borderBottom: "1px solid ".concat(_pittaModules.LightColors.primary["6"])
    },
    cameraDiv: {
      flex: 1,
      padding: theme.spacing(2, 3)
    },
    drawerBtnDiv: {
      height: 68,
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      borderTop: "1px solid ".concat(_pittaModules.LightColors.primary["6"]),
      padding: theme.spacing(2)
    },
    cancelBtn: {
      marginRight: theme.spacing(2)
    },
    searchIcon: {
      "& svg": {
        fontSize: "1rem!important"
      }
    },
    camListDiv: {
      marginTop: theme.spacing(3),
      marginLeft: theme.spacing(1.375)
    },
    camListItem: {
      display: "flex",
      flexDirection: "column",
      marginBottom: theme.spacing(2)
    },
    camName: {
      marginLeft: theme.spacing(0.5)
    },
    modelName: {
      marginLeft: theme.spacing(4.5),
      marginTop: theme.spacing(-1)
    },
    mobileVideoTitleDiv: _defineProperty({
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden",
      maxWidth: "60vw"
    }, theme.breakpoints.down(360), {
      maxWidth: "54vw"
    }),
    videoTitleDiv: {
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden",
      maxWidth: "400px"
    },
    micToggleDiv: _defineProperty({
      marginRight: 18
    }, theme.breakpoints.down(360), {
      marginRight: 6
    }),
    mobileMemuItem: {
      padding: theme.spacing(1.5, 2)
    },
    noGpsDiv: {
      position: "absolute",
      top: 0,
      right: 0,
      left: 0,
      bottom: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: "rgba(19, 19, 28, 0.45)"
    },
    modalTitle: {
      minHeight: 16
    },
    emptyDiv: _defineProperty({
      marginTop: "6.75vh"
    }, theme.breakpoints.up(_pittaModules.Webviewer.mobile), {
      marginTop: "27.7vh"
    }),
    noCamText: {
      marginTop: theme.spacing(1.125)
    },
    disabled: {
      color: "".concat(_pittaModules.LightColors.primary["0"], "40"),
      fill: "".concat(_pittaModules.LightColors.primary["0"], "40")
    },
    ctrlIcon: {
      padding: 0,
      marginRight: theme.spacing(1),
      color: _pittaModules.LightColors.primary["0"],
      fill: _pittaModules.LightColors.primary["0"],
      "&>svg": {
        color: _pittaModules.LightColors.primary["0"],
        fill: _pittaModules.LightColors.primary["0"]
      },
      "&.Mui-disabled": {
        color: "".concat(_pittaModules.LightColors.primary["0"], "40"),
        fill: "".concat(_pittaModules.LightColors.primary["0"], "40")
      }
    },
    videoDiv: {
      width: "100%",
      position: "relative",
      overflow: "hidden",
      backgroundColor: _pittaModules.LightColors.primary["1"],
      paddingTop: "max(350px, calc(100vh - 108px - 188px - 24px - 24px - 49px - 16px))"
    },
    videoDivApp: {
      paddingTop: "75vw"
    },
    hide: {
      display: "none"
    },
    iosModalContent: {
      paddingTop: 32
    },
    fullscreenDiv: {
      position: "fixed",
      top: 0,
      right: 0,
      zIndex: 1200,
      left: 0,
      bottom: 0
    },
    content: {
      flex: 1
    },
    darkMobileMenu: {
      backgroundColor: "black",
      color: _pittaModules.LightColors.primary["0"]
    }
  };
});
var LiveViewPanel = (0, _withStyleProvider.withStyleProvider)(function (props) {
  var _clsx6, _directions$, _clsx9;
  var camera = props.camera,
    clicked = props.clicked,
    dir = props.dir,
    isEvent = props.isEvent,
    isPublic = props.isPublic,
    app = props.app,
    ignoreRemove = props.ignoreRemove,
    notification = props.notification,
    onBack = props.onBack,
    modal = props.modal,
    speedUnit = props.speedUnit,
    noBottom = props.noBottom,
    locationState = props.locationState,
    permissionState = props.permissionState,
    paymentState = props.paymentState,
    cameraState = props.cameraState,
    userState = props.userState,
    liveviewState = props.liveviewState,
    themeState = props.themeState,
    pushEventState = props.pushEventState,
    geofenceState = props.geofenceState,
    groupState = props.groupState,
    onLoadFirmwareSettings = props.onLoadFirmwareSettings,
    onFinishLiveview = props.onFinishLiveview,
    onUpdateLiveviewUsage = props.onUpdateLiveviewUsage,
    onOpenToast = props.onOpenToast,
    onSetFullScreen = props.onSetFullScreen,
    onExitFullScreen = props.onExitFullScreen,
    onSetError = props.onSetError,
    onOpenPricingModal = props.onOpenPricingModal,
    onGoBack = props.onGoBack,
    onExceedLiveview = props.onExceedLiveview,
    onChangeMultiLiveview = props.onChangeMultiLiveview,
    t = props.t,
    noMargin = props.noMargin,
    mapboxModal = props.mapboxModal;
  var classes = useStyles(props);
  var color = themeState.color;
  var history = (0, _reactRouterDom.useHistory)();
  var theme = (0, _styles.useTheme)();
  var query = (0, _useQuery.useQuery)();
  var mobile = (0, _useMediaQuery["default"])(theme.breakpoints.down(_pittaModules.Webviewer.mobile));
  var updateCenter = (0, _react.useRef)(false);
  var prevPSNRef = (0, _react.useRef)(undefined);
  var cancelRequestedRef = (0, _react.useRef)(false);
  var menusRef = (0, _react.useRef)([/*#__PURE__*/(0, _react.createRef)(), /*#__PURE__*/(0, _react.createRef)(), /*#__PURE__*/(0, _react.createRef)(), /*#__PURE__*/(0, _react.createRef)(), /*#__PURE__*/(0, _react.createRef)()]);
  var _useState = (0, _react.useState)(menusRef.current[4]),
    _useState2 = _slicedToArray(_useState, 2),
    menuAnchorRef = _useState2[0],
    setMenuAnchorRef = _useState2[1];
  var gpsWS = locationState.gpsWS,
    gpsWsReadyState = locationState.gpsWsReadyState;
  var permission = permissionState.permission;
  var subscriptionInfo = paymentState.subscriptionInfo;
  var cameraList = cameraState.cameraList,
    publicCams = cameraState.publicCams,
    firmware = cameraState.firmware;
  var usageInfo = userState.usageInfo,
    email = userState.email,
    tokenType = userState.tokenType,
    userProfile = userState.userProfile,
    loginInfo = userState.loginInfo;
  var removePlayer = liveviewState.removePlayer,
    reason = liveviewState.reason,
    withoutBack = liveviewState.withoutBack;
  var fullscreen = themeState.fullscreen,
    colors = themeState.colors;
  var videoSettings = (0, _react.useMemo)(function () {
    var _$find;
    return (_$find = _lodash["default"].find(firmware === null || firmware === void 0 ? void 0 : firmware.cloud_settings, function (c) {
      return c.section_name === "Tab1";
    })) === null || _$find === void 0 ? void 0 : _$find.section_info;
  }, [firmware === null || firmware === void 0 ? void 0 : firmware.cloud_settings]);
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    openMenu = _useState4[0],
    setOpenMenu = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    openCameraMenu = _useState6[0],
    setOpenCameraMenu = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    multiview = _useState8[0],
    setMultiview = _useState8[1];
  var _useState9 = (0, _react.useState)(),
    _useState10 = _slicedToArray(_useState9, 2),
    firmwareConfig = _useState10[0],
    setFirmwareConfig = _useState10[1];
  var _useState11 = (0, _react.useState)([camera, undefined, undefined, undefined]),
    _useState12 = _slicedToArray(_useState11, 2),
    cameras = _useState12[0],
    setCameras = _useState12[1];
  var _useState13 = (0, _react.useState)([dir, undefined, undefined, undefined]),
    _useState14 = _slicedToArray(_useState13, 2),
    directions = _useState14[0],
    setDirections = _useState14[1];
  var _useState15 = (0, _react.useState)(),
    _useState16 = _slicedToArray(_useState15, 2),
    viewIndx = _useState16[0],
    setViewIndx = _useState16[1];
  var _useState17 = (0, _react.useState)(),
    _useState18 = _slicedToArray(_useState17, 2),
    addedCam = _useState18[0],
    setAddedCam = _useState18[1];
  var _useState19 = (0, _react.useState)(),
    _useState20 = _slicedToArray(_useState19, 2),
    setMap = _useState20[1];
  var _useState21 = (0, _react.useState)([]),
    _useState22 = _slicedToArray(_useState21, 2),
    locations = _useState22[0],
    setLocations = _useState22[1];
  var _useState23 = (0, _react.useState)(),
    _useState24 = _slicedToArray(_useState23, 2),
    currentCam = _useState24[0],
    setCurrentCam = _useState24[1];
  var _useState25 = (0, _react.useState)(),
    _useState26 = _slicedToArray(_useState25, 2),
    selectedPSN = _useState26[0],
    setSelectedPSN = _useState26[1];
  var _useState27 = (0, _react.useState)(),
    _useState28 = _slicedToArray(_useState27, 2),
    center = _useState28[0],
    setCenter = _useState28[1];
  var _useState29 = (0, _react.useState)(true),
    _useState30 = _slicedToArray(_useState29, 2),
    disableLiveview = _useState30[0],
    setDisableLiveview = _useState30[1];
  var _useState31 = (0, _react.useState)(false),
    _useState32 = _slicedToArray(_useState31, 2),
    openLimitLiveview = _useState32[0],
    setOpenLimitLiveview = _useState32[1];
  var _useState33 = (0, _react.useState)(""),
    _useState34 = _slicedToArray(_useState33, 2),
    searchKey = _useState34[0],
    setSearchKey = _useState34[1];
  // 7027 - 방향 전환 시, 5초간 방향전환 못하게 수정
  var _useState35 = (0, _react.useState)(false),
    _useState36 = _slicedToArray(_useState35, 2),
    disableDir = _useState36[0],
    setDisableDir = _useState36[1];
  var _useState37 = (0, _react.useState)([false, false, false, false]),
    _useState38 = _slicedToArray(_useState37, 2),
    enableMic = _useState38[0],
    setEnableMic = _useState38[1];
  // 1: 권한 있음, 0: 권한 없음, 2: 권한 없고 팝업 띄우지 말것 (iOS시나리오)
  var _useState39 = (0, _react.useState)(1),
    _useState40 = _slicedToArray(_useState39, 2),
    micPerm = _useState40[0],
    setMicPerm = _useState40[1];
  var _useState41 = (0, _react.useState)(false),
    _useState42 = _slicedToArray(_useState41, 2),
    openNoMicPermModal = _useState42[0],
    setOpenNoMicPermModal = _useState42[1];
  var _useState43 = (0, _react.useState)(false),
    _useState44 = _slicedToArray(_useState43, 2),
    openNoMicPermIOSModal = _useState44[0],
    setOpenNoMicPermIOSModal = _useState44[1];
  var _useState45 = (0, _react.useState)(false),
    _useState46 = _slicedToArray(_useState45, 2),
    disconnected = _useState46[0],
    setDisconnected = _useState46[1];
  // const [isLandscape, setIsLandscape] = useState(false);
  var _useState47 = (0, _react.useState)(0),
    _useState48 = _slicedToArray(_useState47, 2),
    audioLevel = _useState48[0],
    setAudioLevel = _useState48[1];
  var _useState49 = (0, _react.useState)(false),
    _useState50 = _slicedToArray(_useState49, 2),
    micBtnDisabled = _useState50[0],
    setMicBtnDisabled = _useState50[1];
  var _useState51 = (0, _react.useState)(false),
    _useState52 = _slicedToArray(_useState51, 2),
    twoWayInUse = _useState52[0],
    setTwoWayInUse = _useState52[1];
  var _useState53 = (0, _react.useState)(false),
    _useState54 = _slicedToArray(_useState53, 2),
    playingPlayer1 = _useState54[0],
    setPlayingPlayer1 = _useState54[1];
  var _useState55 = (0, _react.useState)(false),
    _useState56 = _slicedToArray(_useState55, 2),
    loadingTwoWay = _useState56[0],
    setLoadingTwoWay = _useState56[1];

  // 11862 - 라이브뷰 소진 팝업을 닫은 적이 있다면 다시 열리지 않도록 하기 위함. (Leehj)
  var _useState57 = (0, _react.useState)(false),
    _useState58 = _slicedToArray(_useState57, 2),
    liveviewPopupWasClosed = _useState58[0],
    setLiveviewPopupWasClosed = _useState58[1];
  var CLOUD_NATIVE = (0, _react.useMemo)(function () {
    // console.log(
    //   "CloudNative",
    //   "CLOUD_NATIVE",
    //   "firmwareConfig",
    //   firmwareConfig,
    //   "!!firmwareConfig?.CloudNative",
    //   !!firmwareConfig?.CloudNative
    // );
    if (firmwareConfig === undefined) {
      return undefined;
    }
    return !!(firmwareConfig !== null && firmwareConfig !== void 0 && firmwareConfig.CloudNative);
  }, [firmwareConfig]);
  (0, _react.useEffect)(function () {
    setDirections([dir, undefined, undefined, undefined]);
  }, [dir]);
  (0, _react.useEffect)(function () {
    console.log("LiveViewPanel", "update camera");
    setCameras(function (cameras) {
      return [camera].concat(_toConsumableArray(_lodash["default"].slice(cameras, 1)));
    });
  }, [camera]);

  // 7027 - 방향 전환 시, 5초간 방향전환 못하게 수정
  (0, _react.useEffect)(function () {
    console.log("LiveViewPanel", disableDir);
    if (disableDir) {
      var timerId = setTimeout(function () {
        console.log("LiveViewPanel", "timerId", timerId);
        setDisableDir(false);
      }, 5000);
      return function () {
        console.log("LiveViewPanel", "clearTimeout", timerId);
        clearTimeout(timerId);
      };
    }
  }, [disableDir]);
  (0, _react.useEffect)(function () {
    if (currentCam !== null && currentCam !== void 0 && currentCam.psn) {
      onLoadFirmwareSettings(currentCam.psn);
    }
  }, [currentCam === null || currentCam === void 0 ? void 0 : currentCam.psn]);

  // 안드로이드에서 back버튼 클릭시, 뷰어를 바로 닫아버림
  // 이로인해, effect hook의 정리 루틴이 정상적으로 실행되지 않아서,
  // webrtc live view 종료가 되지 않는 문제가 발생
  // 안드로이드에서 backpress 이벤트를 받아서, player를 없애고,
  // 가짜 화면을 잠시 나오게 하면서, effect hook의 정리 루틴이 실행될 시간을 만들어줌
  //@ts-ignore
  window.backPressed = window.onBackground = (0, _react.useCallback)(function () {
    // console.log("CloudNative", "window.backPressed", app, !removePlayer);
    if (app && !removePlayer) {
      onFinishLiveview(undefined);
    }
  }, [app, removePlayer]);
  (0, _react.useEffect)(function () {
    if (camera) {
      var config = (0, _pittaModules.getFirmwareConfig)(camera);
      setFirmwareConfig(config);
    }
  }, [camera]);
  (0, _react.useEffect)(function () {
    // 플레이어 종료시, mic 아이콘 off상태로 변경
    if (removePlayer) {
      setEnableMic([false, false, false, false]);
    }
  }, [removePlayer]);
  (0, _react.useEffect)(function () {
    var mic_perm = query.get("mic_perm");
    if (mic_perm) {
      setMicPerm(parseInt(mic_perm));
    }
  }, [query]);
  (0, _react.useEffect)(function () {
    if (twoWayInUse) {
      var timer = setTimeout(function () {
        setTwoWayInUse(false);
      }, 2000);
      return function () {
        clearTimeout(timer);
      };
    }
  }, [twoWayInUse]);

  // useEffect(() => {
  //   if (app) {
  //     const listener = (e) => {
  //       console.log(
  //         "CloudNative",
  //         "isLandscape",
  //         e.target.innerWidth > e.target.innerHeight
  //       );
  //       setIsLandscape(e.target.innerWidth > e.target.innerHeight);
  //     };
  //     window.addEventListener("orientationchange", listener);

  //     return () => {
  //       window.removeEventListener("orientationchange", listener);
  //     };
  //   }
  // }, [app]);

  (0, _react.useEffect)(function () {
    if (app) {
      var _$chain$filter$find$v, _$chain$filter$find$v2;
      var cam = (_$chain$filter$find$v = (_$chain$filter$find$v2 = _lodash["default"].chain(cameraList === null || cameraList === void 0 ? void 0 : cameraList.deviceListInfo).filter(function (d) {
        return d.device.reg_category !== "wifi";
      }).find(function (d) {
        return d.device.psn === (currentCam === null || currentCam === void 0 ? void 0 : currentCam.psn);
      }).value()) === null || _$chain$filter$find$v2 === void 0 ? void 0 : _$chain$filter$find$v2.device) !== null && _$chain$filter$find$v !== void 0 ? _$chain$filter$find$v : _lodash["default"].chain(publicCams).find(function (d) {
        return d.psn === (currentCam === null || currentCam === void 0 ? void 0 : currentCam.psn);
      });
      if ((cam === null || cam === void 0 ? void 0 : cam.active) === "off") {
        // console.log(
        //   "CloudNative",
        //   "request finish liveview due to disconnected dashcam"
        // );
        onFinishLiveview(undefined);
        setDisconnected(true);
        console.log("cam off");
      }
    }
  }, [app, publicCams, cameraList === null || cameraList === void 0 ? void 0 : cameraList.deviceListInfo, currentCam === null || currentCam === void 0 ? void 0 : currentCam.psn]);
  (0, _react.useEffect)(function () {
    if (subscriptionInfo !== null && subscriptionInfo !== void 0 && subscriptionInfo.servicePlanName && ((subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.servicePlanName) === "free" || (subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.servicePlanName.indexOf("lite")) > -1)) {
      console.log("LiveViewPanel", "usageInfo.liveViewDayUsage", usageInfo === null || usageInfo === void 0 ? void 0 : usageInfo.liveViewDayUsage, "usageInfo.LimitLiveView", usageInfo === null || usageInfo === void 0 ? void 0 : usageInfo.LimitLiveView, usageInfo && (usageInfo.LimitLiveView === 0 || usageInfo.liveViewDayUsage < usageInfo.LimitLiveView));
      if (usageInfo && (usageInfo.LimitLiveView === 0 || usageInfo.liveViewDayUsage < usageInfo.LimitLiveView)) {
        // mantis - 12370, 사용량이 제한량보다 작은경우 liveviewPopupWasClosed false처리 (Leehj)
        console.log("LiveViewPanel", "setDisableLiveview(false)");
        setLiveviewPopupWasClosed(false);
        setDisableLiveview(false);
      } else if (usageInfo && usageInfo.LimitLiveView !== 0 && usageInfo.liveViewDayUsage >= usageInfo.LimitLiveView) {
        console.log("LiveViewPanel", "exceedLiveview");
        if (app) {
          // 10861 - 라이브뷰 사용량 초과시 앱으로 메시지 전달 (mckim)
          // exceedLiveview();
          onExceedLiveview();
        } else {
          // 11862 - 라이브뷰 소진 팝업이 열린 적이 없을 때만 실행 (Leehj)
          if (!liveviewPopupWasClosed) {
            setOpenLimitLiveview(true);
          } else {}
        }
      }
    } else if (subscriptionInfo) {
      setDisableLiveview(false);
    }
  }, [usageInfo, subscriptionInfo, app, liveviewPopupWasClosed]);

  // useEffect(() => {
  //   if (loginInfo?.userType === "Etc") {
  //     dispatch(loadUsageInfo());
  //   }
  //   // dispatch(loadCameras());
  // }, [dispatch, loginInfo?.userType]);

  (0, _react.useEffect)(function () {
    if (!permission.liveviewPerm) {
      onGoBack === null || onGoBack === void 0 ? void 0 : onGoBack();
    }
  }, [permission.liveviewPerm]);
  (0, _react.useEffect)(function () {
    if (camera) {
      setCurrentCam(camera);
      setSelectedPSN(camera.psn);
      prevPSNRef.current = camera.psn;
    }
  }, [camera]);
  (0, _react.useEffect)(function () {
    if (mobile) {
      setMultiview(false);
    }
  }, [mobile]);
  (0, _react.useEffect)(function () {
    onChangeMultiLiveview === null || onChangeMultiLiveview === void 0 ? void 0 : onChangeMultiLiveview(multiview);
  }, [onChangeMultiLiveview, multiview]);
  (0, _react.useEffect)(function () {
    console.log("CloudNative1", "try to send gps websocket1", gpsWS, "gpsWsReadyState", gpsWsReadyState, "isPublic", isPublic);
    if (email && gpsWsReadyState === WebSocket.OPEN) {
      // public cam일경우 위치 요청 API 수정 (7143)
      if (isPublic) {
        // dispatch(loadPublicCameraLocation({ psn: camera.psn, cancel }));
        if (camera) {
          var msg = {
            action: "gpsPsnsSpecificDevice",
            email: email,
            psn: camera === null || camera === void 0 ? void 0 : camera.psn,
            sequenceId: new Date().getTime()
          };
          gpsWS === null || gpsWS === void 0 ? void 0 : gpsWS.send(JSON.stringify(msg));
        }
      } else if (permission.multiLiveviewPerm /*|| !app*/) {
        // dispatch(
        //   loadMultiCamLocation({
        //     psns: _.compact([
        //       camera?.psn,
        //       ..._.chain(cameras)
        //         .map((cam) => cam?.psn)
        //         .value(),
        //     ]),
        //     cancel,
        //   })
        // );

        var _msg = {
          action: "gpsPsnsMultiLiveView",
          email: email,
          psns: _lodash["default"].chain([camera === null || camera === void 0 ? void 0 : camera.psn].concat(_toConsumableArray(_lodash["default"].chain(cameras).map(function (cam) {
            return cam === null || cam === void 0 ? void 0 : cam.psn;
          }).value()))).compact().uniq().value(),
          sequenceId: new Date().getTime()
        };
        gpsWS === null || gpsWS === void 0 ? void 0 : gpsWS.send(JSON.stringify(_msg));
      } else {
        console.log("CloudNative1", "try to send gps websocket1", "gpsPsnsMyDevices");
        // GPS WS 생성 시, 내 디바이스 위치가 있는지 확인
        var _msg2 = {
          action: "gpsPsnsMyDevices",
          email: email,
          sequenceId: new Date().getTime()
        };
        gpsWS === null || gpsWS === void 0 ? void 0 : gpsWS.send(JSON.stringify(_msg2));
        // dispatch(loadMyCemrasLocation({ cancel }));
      }
    }
  }, [camera, cameras, permission.multiLiveviewPerm, isPublic, app, email, gpsWsReadyState, gpsWS]);
  (0, _react.useEffect)(function () {
    var locs = [];
    if (cameraList) {
      var psns = [camera === null || camera === void 0 ? void 0 : camera.psn].concat(_toConsumableArray(_lodash["default"].map(cameras, function (c) {
        return c === null || c === void 0 ? void 0 : c.psn;
      })));
      var cams = _lodash["default"].filter(cameraList.deviceListInfo, function (c) {
        return _lodash["default"].includes(psns, c.device.psn);
      });
      // console.log(
      //   "CloudNative3",
      //   "LiveViewPanel",
      //   "psns",
      //   psns,
      //   "cams",
      //   cams,
      //   "publicCams",
      //   publicCams
      // );
      var _iterator = _createForOfIteratorHelper(cams),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var cam = _step.value;
          var device = cam.device;
          if (device.latitude && device.longitude && (device.agree_gps === "on" || app)) {
            var lat = parseFloat(device.latitude);
            var lng = parseFloat(device.longitude);
            locs.push({
              lat: lat,
              lng: lng,
              heading: device.dir_angle ? parseFloat(device.dir_angle) : undefined,
              psn: device.psn,
              name: device.dev_name,
              speed: device.speed,
              mode: device.mode,
              model: device.model,
              active: device.active,
              agree_gps: device.agree_gps,
              isPublic: false
            });
            if (device.psn === selectedPSN && (updateCenter.current || !multiview)) {
              // 멀티 라이브뷰 상태일때만 1회 위치 변경
              if (multiview) {
                updateCenter.current = false;
              }
              setCenter({
                lat: lat,
                lng: lng
              });
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    var found = _lodash["default"].find(publicCams, function (cam) {
      return cam.psn === (camera === null || camera === void 0 ? void 0 : camera.psn);
    });
    if (found) {
      var _lat = found.lat,
        _lng = found.lng;
      locs.push({
        lat: found.lat,
        lng: found.lng,
        // mantis - 10315, 카메라의 Live view 진입 시 heading이 0으로 출력되어 지도 위 카메라 방향이 비정상적으로 출력 되는 이슈 수정 (Leehj)
        heading: (camera === null || camera === void 0 ? void 0 : camera.share_gps) === "on" && found.dir_angle ? parseFloat(found.dir_angle) : undefined,
        psn: found.psn,
        name: (camera === null || camera === void 0 ? void 0 : camera.share_dev_name) === "on" ? found.dev_name : undefined,
        speed: found.speed,
        mode: found.mode,
        active: found.active,
        share_video: found.share_video,
        profile_img: found.profile_img,
        isPublic: true
      });
      setCenter({
        lat: _lat,
        lng: _lng
      });
    }

    // console.log("CloudNative3", "LiveViewPanel", "locs", locs);

    setLocations(locs);
  }, [app, camera === null || camera === void 0 ? void 0 : camera.psn, camera === null || camera === void 0 ? void 0 : camera.share_dev_name, camera === null || camera === void 0 ? void 0 : camera.share_gps, cameraList, cameras, multiview, publicCams, selectedPSN]);

  //Blackvue7 Box 옵션 카메라 방향 추가 (8460)
  var isOptionModel = (0, _react.useMemo)(function () {
    return _lodash["default"].includes(_pittaModules.OPTION_CAMERA_MODELS, camera === null || camera === void 0 ? void 0 : camera.model);
  }, [camera === null || camera === void 0 ? void 0 : camera.model]);
  var setCamDirection = (0, _react.useCallback)(function (dir) {
    var indx = _lodash["default"].findIndex(cameras, function (dev) {
      return (dev === null || dev === void 0 ? void 0 : dev.psn) === (currentCam === null || currentCam === void 0 ? void 0 : currentCam.psn);
    });
    setOpenMenu(false);
    if (indx > -1) {
      setDirections(function (d) {
        d[indx] = dir;
        return _toConsumableArray(d);
      });
    }
    if (dir !== directions[indx]) {
      setDisableDir(true);
    }
  }, [cameras, currentCam === null || currentCam === void 0 ? void 0 : currentCam.psn, directions]);
  var directionMenuMarkup = (0, _react.useMemo)(function () {
    var _directions$indx, _clsx3, _clsx4;
    console.log("LiveViewPanel", "update direction markup");
    var indx = _lodash["default"].findIndex(cameras, function (dev) {
      return (dev === null || dev === void 0 ? void 0 : dev.psn) === (currentCam === null || currentCam === void 0 ? void 0 : currentCam.psn);
    });
    var dir = (_directions$indx = directions[indx]) !== null && _directions$indx !== void 0 ? _directions$indx : 1;

    //Blackvue7 Box 옵션 카메라 방향 추가 (8460)
    var direction3rd = undefined;
    if (_lodash["default"].includes(_pittaModules.MODELS_3CH, camera === null || camera === void 0 ? void 0 : camera.model)) {
      if (isOptionModel) {
        var _clsx;
        direction3rd = /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.WebMenuItem, {
          key: "direction-option",
          startIcon: !mobile && dir === _pittaModules.Option && /*#__PURE__*/_react["default"].createElement(_Check["default"], {
            fontSize: "small",
            htmlColor: colors.primary["1"]
          }),
          endIcon: mobile && dir === _pittaModules.Option && /*#__PURE__*/_react["default"].createElement(_Check["default"], {
            fontSize: "small",
            htmlColor: colors.primary["1"]
          }),
          className: (0, _clsx10["default"])((_clsx = {}, _defineProperty(_clsx, classes.uncheckedMenu, dir !== _pittaModules.Option && !mobile), _defineProperty(_clsx, classes.mobileMemuItem, mobile), _clsx)),
          onClick: function onClick() {
            return setCamDirection(_pittaModules.Option);
          }
        }, t("Option"));
      } else {
        var _clsx2;
        direction3rd = /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.WebMenuItem, {
          key: "direction-interior",
          startIcon: !mobile && dir === _pittaModules.Interior && /*#__PURE__*/_react["default"].createElement(_Check["default"], {
            fontSize: "small",
            htmlColor: colors.primary["1"]
          }),
          endIcon: mobile && dir === _pittaModules.Interior && /*#__PURE__*/_react["default"].createElement(_Check["default"], {
            fontSize: "small",
            htmlColor: colors.primary["1"]
          }),
          className: (0, _clsx10["default"])((_clsx2 = {}, _defineProperty(_clsx2, classes.uncheckedMenu, dir !== _pittaModules.Interior && !mobile), _defineProperty(_clsx2, classes.mobileMemuItem, mobile), _clsx2)),
          onClick: function onClick() {
            return setCamDirection(_pittaModules.Interior);
          }
        }, t("Interior"));
      }
    }
    return _lodash["default"].compact([/*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.WebMenuItem, {
      key: "direction-front",
      startIcon: !mobile && dir === _pittaModules.Front && /*#__PURE__*/_react["default"].createElement(_Check["default"], {
        fontSize: "small",
        htmlColor: colors.primary["1"]
      }),
      endIcon: mobile && dir === _pittaModules.Front && /*#__PURE__*/_react["default"].createElement(_Check["default"], {
        fontSize: "small",
        htmlColor: colors.primary["1"]
      }),
      className: (0, _clsx10["default"])((_clsx3 = {}, _defineProperty(_clsx3, classes.uncheckedMenu, dir !== _pittaModules.Front && !mobile), _defineProperty(_clsx3, classes.mobileMemuItem, mobile), _clsx3)),
      onClick: function onClick() {
        return setCamDirection(_pittaModules.Front);
      }
    }, t("Front")), _lodash["default"].includes([].concat(_toConsumableArray(_pittaModules.MODELS_2CH), _toConsumableArray(_pittaModules.MODELS_3CH)), currentCam === null || currentCam === void 0 ? void 0 : currentCam.model) && /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.WebMenuItem, {
      key: "direction-rear",
      startIcon: !mobile && dir === _pittaModules.Rear && /*#__PURE__*/_react["default"].createElement(_Check["default"], {
        fontSize: "small",
        htmlColor: colors.primary["1"]
      }),
      endIcon: mobile && dir === _pittaModules.Rear && /*#__PURE__*/_react["default"].createElement(_Check["default"], {
        fontSize: "small",
        htmlColor: colors.primary["1"]
      }),
      className: (0, _clsx10["default"])((_clsx4 = {}, _defineProperty(_clsx4, classes.uncheckedMenu, dir !== _pittaModules.Rear && !mobile), _defineProperty(_clsx4, classes.mobileMemuItem, mobile), _clsx4)),
      onClick: function onClick() {
        return setCamDirection(_pittaModules.Rear);
      }
    }, t("Rear")), direction3rd]);
  }, [camera === null || camera === void 0 ? void 0 : camera.model, cameras, classes.mobileMemuItem, classes.uncheckedMenu, currentCam === null || currentCam === void 0 ? void 0 : currentCam.model, currentCam === null || currentCam === void 0 ? void 0 : currentCam.psn, directions, isOptionModel, mobile, setCamDirection, t]);
  var handleChannelChange = (0, _react.useCallback)(function (indx) {
    return function (dir, failed) {
      // console.log("CloudNative", "handleChannelChange", dir, failed);
      if (failed) {
        setDisableDir(false);
      }
      setDirections(function (d) {
        d[indx] = dir;
        return _toConsumableArray(d);
      });
    };
  }, []);
  var stopVoiceCall = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(enabledIndx) {
      var cam;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            cancelRequestedRef.current = true;
            setLoadingTwoWay(true);
            cam = cameras[enabledIndx];
            if (!cam) {
              _context.next = 7;
              break;
            }
            _context.next = 6;
            return _pittaModules.jwtAxiosInst.post("/IoT/devicecommand", {
              command: "TwoWayStop",
              email: email,
              user_token: loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.user_token,
              tokenType: tokenType,
              psn: cam.psn
            });
          case 6:
            setEnableMic(function (e) {
              e[enabledIndx] = false;
              return _toConsumableArray(e);
            });
          case 7:
            setLoadingTwoWay(false);
            cancelRequestedRef.current = false;
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [cameras, email, loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.user_token, tokenType]);
  (0, _react.useEffect)(function () {
    var camIndx = _lodash["default"].findIndex(cameras, function (c) {
      return (c === null || c === void 0 ? void 0 : c.psn) === selectedPSN;
    });
    var enabledIndx = _lodash["default"].findIndex(enableMic, function (e) {
      return e;
    });
    // console.log("CloudNative", camIndx, enabledIndx);
    if (enabledIndx > -1 && camIndx !== enabledIndx) {
      stopVoiceCall(enabledIndx);
    }
  }, [cameras, enableMic, selectedPSN, stopVoiceCall]);

  // 클라우드 네이티브 two way voice command api 처리
  var toggleMic = (0, _react.useCallback)(function (index) {
    return /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var browser, _window$Webviewer, enabledCam, enabled, resp, data, status;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(index > -1)) {
              _context2.next = 20;
              break;
            }
            if (!(micPerm === 0)) {
              _context2.next = 16;
              break;
            }
            browser = (0, _detectBrowser.detect)();
            onExitFullScreen({});
            if (!((browser === null || browser === void 0 ? void 0 : browser.name) === "ios-webview")) {
              _context2.next = 8;
              break;
            }
            return _context2.abrupt("return", webkit.messageHandlers.alert.postMessage({
              reason: "NO_MIC_PERMISSION"
            }));
          case 8:
            if (!((browser === null || browser === void 0 ? void 0 : browser.name) === "chromium-webview")) {
              _context2.next = 12;
              break;
            }
            return _context2.abrupt("return", (_window$Webviewer = window.Webviewer) === null || _window$Webviewer === void 0 ? void 0 : _window$Webviewer.alert(JSON.stringify({
              reason: "NO_MIC_PERMISSION"
            })));
          case 12:
            setOpenNoMicPermModal(true);
          case 13:
            return _context2.abrupt("return");
          case 16:
            if (!(micPerm === 2)) {
              _context2.next = 20;
              break;
            }
            setOpenNoMicPermIOSModal(true);
            onExitFullScreen({});
            return _context2.abrupt("return");
          case 20:
            _context2.prev = 20;
            setLoadingTwoWay(true);
            setMicBtnDisabled(true);
            if (!(index > -1)) {
              _context2.next = 45;
              break;
            }
            enabledCam = cameras[index];
            enabled = enableMic[index]; // console.log(
            //   "CloudNative",
            //   "enabledCam",
            //   enabledCam,
            //   "enabled",
            //   enabled
            // );
            if (enabledCam) {
              _context2.next = 28;
              break;
            }
            return _context2.abrupt("return");
          case 28:
            if (!enabled) {
              _context2.next = 37;
              break;
            }
            if (cancelRequestedRef.current) {
              _context2.next = 35;
              break;
            }
            cancelRequestedRef.current = true;
            _context2.next = 33;
            return _pittaModules.jwtAxiosInst.post("/IoT/devicecommand", {
              command: "TwoWayStop",
              email: email,
              user_token: loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.user_token,
              tokenType: tokenType,
              psn: enabledCam.psn
            });
          case 33:
            setEnableMic(function (e) {
              e[index] = false;
              return _toConsumableArray(e);
            });
            cancelRequestedRef.current = false;
          case 35:
            _context2.next = 43;
            break;
          case 37:
            prevPSNRef.current = enabledCam.psn;
            // console.log("CloudNative", "PSN", "Start", prevPSNRef.current);
            _context2.next = 40;
            return _pittaModules.jwtAxiosInst.post("/IoT/devicecommand", {
              command: "TwoWayStart",
              email: email,
              user_token: loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.user_token,
              tokenType: tokenType,
              psn: enabledCam.psn
            });
          case 40:
            resp = _context2.sent;
            if (typeof resp.data === "string") {
              data = JSON.parse(resp.data);
            } else {
              data = resp.data;
            }
            if (data.resultcode === "BC_ERR_OK") {
              status = data.status;
              if (status === "busy") {
                setTwoWayInUse(true);
              }
              setEnableMic(function (e) {
                e[index] = status === "free";
                return _toConsumableArray(e);
              });
            }
          case 43:
            _context2.next = 46;
            break;
          case 45:
            prevPSNRef.current = selectedPSN;
          case 46:
            _context2.prev = 46;
            // twoway 버튼 클릭 후, api응답 받으면 2초후 버튼 활성화
            setTimeout(function () {
              setMicBtnDisabled(false);
            }, 2000);
            setLoadingTwoWay(false);
            return _context2.finish(46);
          case 50:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[20,, 46, 50]]);
    }));
  }, [cameras, email, enableMic, loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.user_token, micPerm, selectedPSN, tokenType]);
  (0, _react.useEffect)(function () {
    if (micPerm !== 1) {
      var enabledIndx = _lodash["default"].findIndex(enableMic, function (e) {
        return e;
      });
      stopVoiceCall(enabledIndx);
    }
  }, [enableMic, micPerm, stopVoiceCall]);
  var handleNoMicPerm = (0, _react.useCallback)(function (ignore) {
    setMicPerm(function (p) {
      if (p === 1) {
        return ignore ? 2 : 0;
      }
      return p;
    });
  }, []);
  (0, _react.useEffect)(function () {
    // console.log(
    //   "CloudNative",
    //   "PSN",
    //   prevPSNRef.current,
    //   selectedPSN,
    //   cancelRequestedRef.current
    // );
    if (selectedPSN && prevPSNRef.current !== selectedPSN && !cancelRequestedRef.current) {
      toggleMic(-1)();
    }
  }, [selectedPSN, toggleMic]);
  (0, _react.useEffect)(function () {
    var _navigator;
    // iOS 13 버전에서 navigator.mediaDevices가 undefined인 경우 수정
    if ((_navigator = navigator) !== null && _navigator !== void 0 && _navigator.mediaDevices) {
      navigator.mediaDevices.ondevicechange = /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(event) {
          var devices, _iterator2, _step2, device;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return navigator.mediaDevices.enumerateDevices();
              case 2:
                devices = _context3.sent;
                _iterator2 = _createForOfIteratorHelper(devices);
                _context3.prev = 4;
                _iterator2.s();
              case 6:
                if ((_step2 = _iterator2.n()).done) {
                  _context3.next = 13;
                  break;
                }
                device = _step2.value;
                if (!(device.kind === "audioinput")) {
                  _context3.next = 11;
                  break;
                }
                // console.log("CloudNative", "find new audio input", device);
                setMicPerm(1);
                return _context3.abrupt("break", 13);
              case 11:
                _context3.next = 6;
                break;
              case 13:
                _context3.next = 18;
                break;
              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3["catch"](4);
                _iterator2.e(_context3.t0);
              case 18:
                _context3.prev = 18;
                _iterator2.f();
                return _context3.finish(18);
              case 21:
              case "end":
                return _context3.stop();
            }
          }, _callee3, null, [[4, 15, 18, 21]]);
        }));
        return function (_x2) {
          return _ref3.apply(this, arguments);
        };
      }();
      return function () {
        navigator.mediaDevices.ondevicechange = null;
      };
    }
  }, []);
  var handleChannelChange1 = (0, _react.useMemo)(function () {
    return handleChannelChange(0);
  }, [handleChannelChange]);
  var handleChannelChange2 = (0, _react.useMemo)(function () {
    return handleChannelChange(1);
  }, [handleChannelChange]);
  var handleChannelChange3 = (0, _react.useMemo)(function () {
    return handleChannelChange(2);
  }, [handleChannelChange]);
  var handleChannelChange4 = (0, _react.useMemo)(function () {
    return handleChannelChange(3);
  }, [handleChannelChange]);
  var playerMarkup1 = (0, _react.useMemo)(function () {
    var _cameras$, _cameras$2, _cameras$3;
    // console.log(
    //   "CloudNative",
    //   "playerMarkup1",
    //   "removePlayer",
    //   removePlayer,
    //   "ignoreRemove",
    //   ignoreRemove,
    //   "micBtnDisabled",
    //   micBtnDisabled
    // );
    return removePlayer && !ignoreRemove ? /*#__PURE__*/_react["default"].createElement(_LiveViewPlayer.LiveViewPlayer, {
      camera: undefined,
      clicked: clicked,
      direction: directions[0],
      main: true,
      disabled: true,
      multiView: multiview,
      onChannelChange: handleChannelChange1,
      app: app,
      modal: modal,
      cameraState: cameraState,
      userState: userState,
      paymentState: paymentState,
      liveviewState: liveviewState,
      themeState: themeState,
      onFinishLiveview: onFinishLiveview,
      onUpdateLiveviewUsage: onUpdateLiveviewUsage,
      onOpenToast: onOpenToast,
      onSetFullScreen: onSetFullScreen,
      onExitFullScreen: onExitFullScreen,
      onSetError: onSetError,
      onChangePlaying: function onChangePlaying() {},
      t: t
      // paddingTop값을 변경하기 위함
      ,
      mapboxModal: mapboxModal
    }) : /*#__PURE__*/_react["default"].createElement(_LiveViewPlayer.LiveViewPlayer, {
      camera: cameras[0],
      isPublic: isPublic,
      clicked: clicked,
      main: true,
      disabled: disableLiveview,
      multiView: multiview,
      selected: selectedPSN === ((_cameras$ = cameras[0]) === null || _cameras$ === void 0 ? void 0 : _cameras$.psn),
      direction: directions[0],
      onChangePlaying: setPlayingPlayer1
      // landscape={isLandscape}
      ,
      menuAnchorRef: menusRef.current[0],
      onMenuOpen: function onMenuOpen() {
        // mantis - 10092, 카메라 방향 드롭박스가 open된 채로 전체화면을 나가면 전체화면이 아닐 때 출력되는 카메라 방향 드롭박스를 열어준다.
        //  방향메뉴의 위치가 상이해져서 setMenuAnchorRef(menusRef.current[0])는 주석처리 (Leehj)
        setOpenMenu(function (o) {
          return !o;
        });
        // setMenuAnchorRef(menusRef.current[0]);
        setCurrentCam(cameras[0]);
      },
      onChannelChange: handleChannelChange1,
      app: app,
      enableMic: enableMic[0],
      onToggleMic: toggleMic(0),
      onAudioLevelChanged: setAudioLevel,
      onNoMicPerm: handleNoMicPerm,
      micBtnDisabled: micBtnDisabled,
      twoWayInUse: twoWayInUse && selectedPSN === ((_cameras$2 = cameras[0]) === null || _cameras$2 === void 0 ? void 0 : _cameras$2.psn),
      modal: modal,
      loadingTwoWay: loadingTwoWay && selectedPSN === ((_cameras$3 = cameras[0]) === null || _cameras$3 === void 0 ? void 0 : _cameras$3.psn),
      cameraState: cameraState,
      userState: userState,
      paymentState: paymentState,
      liveviewState: liveviewState,
      themeState: themeState,
      onFinishLiveview: onFinishLiveview,
      onUpdateLiveviewUsage: onUpdateLiveviewUsage,
      onOpenToast: onOpenToast,
      onSetFullScreen: onSetFullScreen,
      onExitFullScreen: onExitFullScreen,
      onSetError: onSetError,
      t: t
      // paddingTop값을 변경하기 위함
      // mapboxModal={mapboxModal}
    });
  }, [app, cameraState, cameras, directions, disableLiveview, enableMic, handleChannelChange1, handleNoMicPerm, ignoreRemove, isPublic, liveviewState, loadingTwoWay, clicked, micBtnDisabled, modal, multiview, paymentState, removePlayer, selectedPSN, themeState, toggleMic, twoWayInUse, userState, onFinishLiveview, onUpdateLiveviewUsage, onOpenToast, onSetFullScreen, onExitFullScreen, onSetError]);
  (0, _react.useEffect)(function () {
    if (removePlayer) {
      setCameras([camera, undefined, undefined, undefined]);
    }
  }, [camera, removePlayer]);
  (0, _react.useEffect)(function () {
    // console.log("CloudNative", "back", app, removePlayer);
    if (app && removePlayer) {
      // console.log(
      //   "CloudNative",
      //   "onBack",
      //   disconnected ? "DEVICE_DISCONNECT" : reason,
      //   "withoutBack",
      //   withoutBack
      // );
      if (withoutBack !== true) {
        onBack === null || onBack === void 0 ? void 0 : onBack(disconnected ? "DEVICE_DISCONNECT" : reason);
      }
    }
  }, [app, removePlayer, onBack, disconnected, reason]);
  var playerMarkup2 = (0, _react.useMemo)(function () {
    var _cameras$4, _cameras$5, _cameras$6;
    return removePlayer ? /*#__PURE__*/_react["default"].createElement(_LiveViewPlayer.LiveViewPlayer, {
      camera: undefined,
      clicked: clicked,
      direction: directions[1],
      main: true,
      disabled: true,
      multiView: multiview,
      onChannelChange: handleChannelChange2,
      app: app,
      cameraState: cameraState,
      userState: userState,
      paymentState: paymentState,
      liveviewState: liveviewState,
      themeState: themeState,
      onFinishLiveview: onFinishLiveview,
      onUpdateLiveviewUsage: onUpdateLiveviewUsage,
      onOpenToast: onOpenToast,
      onSetFullScreen: onSetFullScreen,
      onExitFullScreen: onExitFullScreen,
      onSetError: onSetError,
      t: t
    }) : /*#__PURE__*/_react["default"].createElement(_LiveViewPlayer.LiveViewPlayer, {
      camera: cameras[1],
      disabled: disableLiveview,
      selected: selectedPSN === ((_cameras$4 = cameras[1]) === null || _cameras$4 === void 0 ? void 0 : _cameras$4.psn),
      onAddCamera: function onAddCamera() {
        setViewIndx(1);
        setOpenCameraMenu(true);
      },
      onMenuOpen: function onMenuOpen() {
        setMenuAnchorRef(menusRef.current[1]);
        setOpenMenu(function (o) {
          return !o;
        });
        setCurrentCam(cameras[1]);
      },
      menuAnchorRef: menusRef.current[1],
      multiView: multiview,
      direction: directions[1],
      onClose: function onClose() {
        cameras[1] = undefined;
        setCameras(_toConsumableArray(cameras));
      },
      onChannelChange: handleChannelChange2,
      enableMic: enableMic[1],
      onToggleMic: toggleMic(1),
      micBtnDisabled: micBtnDisabled,
      twoWayInUse: twoWayInUse && selectedPSN === ((_cameras$5 = cameras[1]) === null || _cameras$5 === void 0 ? void 0 : _cameras$5.psn),
      loadingTwoWay: loadingTwoWay && selectedPSN === ((_cameras$6 = cameras[1]) === null || _cameras$6 === void 0 ? void 0 : _cameras$6.psn),
      cameraState: cameraState,
      userState: userState,
      paymentState: paymentState,
      liveviewState: liveviewState,
      themeState: themeState,
      onFinishLiveview: onFinishLiveview,
      onUpdateLiveviewUsage: onUpdateLiveviewUsage,
      onOpenToast: onOpenToast,
      onSetFullScreen: onSetFullScreen,
      onExitFullScreen: onExitFullScreen,
      onSetError: onSetError,
      t: t
    });
  }, [app, cameraState, cameras, directions, disableLiveview, enableMic, handleChannelChange2, liveviewState, loadingTwoWay, clicked, micBtnDisabled, multiview, paymentState, removePlayer, selectedPSN, themeState, toggleMic, twoWayInUse, userState, onFinishLiveview, onUpdateLiveviewUsage, onOpenToast, onSetFullScreen, onExitFullScreen, onSetError]);
  var playerMarkup3 = (0, _react.useMemo)(function () {
    var _cameras$7, _cameras$8, _cameras$9;
    return removePlayer ? /*#__PURE__*/_react["default"].createElement(_LiveViewPlayer.LiveViewPlayer, {
      camera: undefined,
      clicked: clicked,
      direction: directions[2],
      main: true,
      disabled: true,
      multiView: multiview,
      onChannelChange: handleChannelChange3,
      app: app,
      cameraState: cameraState,
      userState: userState,
      paymentState: paymentState,
      liveviewState: liveviewState,
      themeState: themeState,
      onFinishLiveview: onFinishLiveview,
      onUpdateLiveviewUsage: onUpdateLiveviewUsage,
      onOpenToast: onOpenToast,
      onSetFullScreen: onSetFullScreen,
      onExitFullScreen: onExitFullScreen,
      onSetError: onSetError,
      t: t
    }) : /*#__PURE__*/_react["default"].createElement(_LiveViewPlayer.LiveViewPlayer, {
      camera: cameras[2],
      disabled: disableLiveview,
      selected: selectedPSN === ((_cameras$7 = cameras[2]) === null || _cameras$7 === void 0 ? void 0 : _cameras$7.psn),
      onAddCamera: function onAddCamera() {
        setViewIndx(2);
        setOpenCameraMenu(true);
      },
      onMenuOpen: function onMenuOpen() {
        setMenuAnchorRef(menusRef.current[2]);
        setOpenMenu(function (o) {
          return !o;
        });
        setCurrentCam(cameras[2]);
      },
      menuAnchorRef: menusRef.current[2],
      multiView: multiview,
      direction: directions[2],
      onClose: function onClose() {
        cameras[2] = undefined;
        setCameras(_toConsumableArray(cameras));
      },
      onChannelChange: handleChannelChange3,
      enableMic: enableMic[2],
      onToggleMic: toggleMic(2),
      micBtnDisabled: micBtnDisabled,
      twoWayInUse: twoWayInUse && selectedPSN === ((_cameras$8 = cameras[2]) === null || _cameras$8 === void 0 ? void 0 : _cameras$8.psn),
      loadingTwoWay: loadingTwoWay && selectedPSN === ((_cameras$9 = cameras[2]) === null || _cameras$9 === void 0 ? void 0 : _cameras$9.psn),
      cameraState: cameraState,
      userState: userState,
      paymentState: paymentState,
      liveviewState: liveviewState,
      themeState: themeState,
      onFinishLiveview: onFinishLiveview,
      onUpdateLiveviewUsage: onUpdateLiveviewUsage,
      onOpenToast: onOpenToast,
      onSetFullScreen: onSetFullScreen,
      onExitFullScreen: onExitFullScreen,
      onSetError: onSetError,
      t: t
    });
  }, [app, cameraState, cameras, directions, disableLiveview, enableMic, handleChannelChange3, liveviewState, loadingTwoWay, clicked, micBtnDisabled, multiview, paymentState, removePlayer, selectedPSN, themeState, toggleMic, twoWayInUse, userState, onFinishLiveview, onUpdateLiveviewUsage, onOpenToast, onSetFullScreen, onExitFullScreen, onSetError]);
  var playerMarkup4 = (0, _react.useMemo)(function () {
    var _cameras$10, _cameras$11, _cameras$12;
    return removePlayer ? /*#__PURE__*/_react["default"].createElement(_LiveViewPlayer.LiveViewPlayer, {
      camera: undefined,
      clicked: clicked,
      direction: directions[3],
      main: true,
      disabled: true,
      multiView: multiview,
      onChannelChange: handleChannelChange4,
      app: app,
      cameraState: cameraState,
      userState: userState,
      paymentState: paymentState,
      liveviewState: liveviewState,
      themeState: themeState,
      onFinishLiveview: onFinishLiveview,
      onUpdateLiveviewUsage: onUpdateLiveviewUsage,
      onOpenToast: onOpenToast,
      onSetFullScreen: onSetFullScreen,
      onExitFullScreen: onExitFullScreen,
      onSetError: onSetError,
      t: t
    }) : /*#__PURE__*/_react["default"].createElement(_LiveViewPlayer.LiveViewPlayer, {
      camera: cameras[3],
      disabled: disableLiveview,
      selected: selectedPSN === ((_cameras$10 = cameras[3]) === null || _cameras$10 === void 0 ? void 0 : _cameras$10.psn),
      onAddCamera: function onAddCamera() {
        setViewIndx(3);
        setOpenCameraMenu(true);
      },
      onMenuOpen: function onMenuOpen() {
        setMenuAnchorRef(menusRef.current[3]);
        setOpenMenu(function (o) {
          return !o;
        });
        setCurrentCam(cameras[3]);
      },
      menuAnchorRef: menusRef.current[3],
      multiView: multiview,
      direction: directions[3],
      onClose: function onClose() {
        cameras[3] = undefined;
        setCameras(_toConsumableArray(cameras));
      },
      onChannelChange: handleChannelChange4,
      enableMic: enableMic[3],
      onToggleMic: toggleMic(3),
      micBtnDisabled: micBtnDisabled,
      twoWayInUse: twoWayInUse && selectedPSN === ((_cameras$11 = cameras[3]) === null || _cameras$11 === void 0 ? void 0 : _cameras$11.psn),
      loadingTwoWay: loadingTwoWay && selectedPSN === ((_cameras$12 = cameras[3]) === null || _cameras$12 === void 0 ? void 0 : _cameras$12.psn),
      cameraState: cameraState,
      userState: userState,
      paymentState: paymentState,
      liveviewState: liveviewState,
      themeState: themeState,
      onFinishLiveview: onFinishLiveview,
      onUpdateLiveviewUsage: onUpdateLiveviewUsage,
      onOpenToast: onOpenToast,
      onSetFullScreen: onSetFullScreen,
      onExitFullScreen: onExitFullScreen,
      onSetError: onSetError,
      t: t
    });
  }, [app, cameraState, cameras, directions, disableLiveview, enableMic, handleChannelChange4, liveviewState, loadingTwoWay, clicked, micBtnDisabled, multiview, paymentState, removePlayer, selectedPSN, themeState, toggleMic, twoWayInUse, userState, onFinishLiveview, onUpdateLiveviewUsage, onOpenToast, onSetFullScreen, onExitFullScreen, onSetError]);

  // const candidateCams = useMemo(() => {
  //   return _.chain(cameraList?.DeviceListInfo)
  //     .filter((cam) => cam.device.psn !== camera?.psn)
  //     .map((dev) => dev.device)
  //     .value();
  // }, [camera?.psn, cameraList?.DeviceListInfo]);

  var candidateCams = (0, _react.useMemo)(function () {
    return _lodash["default"].chain(cameraList === null || cameraList === void 0 ? void 0 : cameraList.deviceListInfo).filter(function (cam) {
      return !_lodash["default"].chain(cameras).map(function (c) {
        return c === null || c === void 0 ? void 0 : c.psn;
      }).includes(cam.device.psn).value();
    }).value();
  }, [cameraList === null || cameraList === void 0 ? void 0 : cameraList.deviceListInfo, cameras]);
  var filteredCameras = (0, _react.useMemo)(function () {
    // mantis - 11836, 멀티뷰에서 wifi 카메라는 아예 미노출로 수정 (Leehj)
    var wifiFilterCam = _lodash["default"].filter(candidateCams, function (dev) {
      var loggined = !dev.device.login_date ? false : !(0, _moment["default"])(dev.device.login_date).isBefore(_moment["default"].utc(0));
      if (dev.device.reg_category === "cloud" && loggined) {
        return dev;
      }
    });
    return _lodash["default"].filter(wifiFilterCam, function (camera) {
      return camera.device.dev_name.toLowerCase().indexOf(searchKey.toLowerCase()) > -1 || camera.device.model.toLowerCase().indexOf(searchKey.toLowerCase()) > -1;
    });
  }, [candidateCams, searchKey]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx10["default"])(classes.content, _defineProperty({}, classes.fullscreenDiv, app && fullscreen))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx10["default"])(classes.menuDiv)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, !multiview ? /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
    category: "Default",
    variant: "Body",
    className: (0, _clsx10["default"])((_clsx6 = {}, _defineProperty(_clsx6, classes.mobileVideoTitleDiv, mobile), _defineProperty(_clsx6, classes.videoTitleDiv, !mobile), _clsx6))
  }, cameras[0] && (cameras[0].share_dev_name === "off" && isPublic ? "BLACKVUE" : "".concat(cameras[0].dev_name, " (").concat(cameras[0].model, ")"))) : /*#__PURE__*/_react["default"].createElement("div", null)), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, CLOUD_NATIVE && !isPublic && !multiview && (userProfile === null || userProfile === void 0 ? void 0 : userProfile.userType) !== "User" && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.micToggleDiv
  }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.MicToggle, {
    enableMic: enableMic[0],
    volume: audioLevel,
    onToggleMic: toggleMic(0),
    disabled: micBtnDisabled || !playingPlayer1,
    loading: loadingTwoWay,
    fullscreen: fullscreen
  })), !multiview && !isPublic &&
  /*#__PURE__*/
  // 7027 - 방향 전환 시, 5초간 방향전환 못하게 수정
  _react["default"].createElement("div", {
    className: (0, _clsx10["default"])(classes.dirDiv, _defineProperty({}, classes.disabled, disableDir || !playingPlayer1)),
    ref: menusRef.current[4],
    onClick: function onClick() {
      if (!disableDir && playingPlayer1) {
        setOpenMenu(function (o) {
          return !o;
        });
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
    category: "Default",
    variant: "BodyBold"
  }, t((0, _pittaModules.getDirection)((_directions$ = directions[0]) !== null && _directions$ !== void 0 ? _directions$ : 1, isOptionModel))), /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], {
    fontSize: "small",
    style: {
      fill: disableDir ? "".concat(_pittaModules.LightColors.primary["0"], "40") : undefined
    }
  })), !mobile && !isEvent && !isPublic && permission.multiLiveviewPerm && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
    category: "Default",
    variant: "BodyBold",
    className: classes.multiViewTextDiv
  }, t("Multi View")), /*#__PURE__*/_react["default"].createElement(StyledSwitch, {
    color: "primary",
    checked: multiview,
    onChange: function onChange(e, checked) {
      if (!checked) {
        setMenuAnchorRef(menusRef.current[4]);
        setCameras([camera, undefined, undefined, undefined]);
        setDirections(function (d) {
          return [d[0], undefined, undefined, undefined];
        });
        setEnableMic(function (e) {
          return [e[0], false, false, false];
        });
        setSelectedPSN(camera === null || camera === void 0 ? void 0 : camera.psn);
      }
      setMultiview(checked);
    }
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.multiViewDiv
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx10["default"])(classes.liveViewDiv, _defineProperty({}, classes.sLiveViewDiv, !multiview)),
    onClick: function onClick() {
      var _cameras$13;
      updateCenter.current = true;
      setSelectedPSN((_cameras$13 = cameras[0]) === null || _cameras$13 === void 0 ? void 0 : _cameras$13.psn);
    }
  }, playerMarkup1), multiview && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx10["default"])(classes.liveViewDiv),
    onClick: function onClick() {
      var _cameras$14;
      updateCenter.current = true;
      setSelectedPSN((_cameras$14 = cameras[1]) === null || _cameras$14 === void 0 ? void 0 : _cameras$14.psn);
    }
  }, playerMarkup2), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx10["default"])(classes.liveViewDiv),
    onClick: function onClick() {
      var _cameras$15;
      updateCenter.current = true;
      setSelectedPSN((_cameras$15 = cameras[2]) === null || _cameras$15 === void 0 ? void 0 : _cameras$15.psn);
    }
  }, playerMarkup3), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx10["default"])(classes.liveViewDiv),
    onClick: function onClick() {
      var _cameras$16;
      updateCenter.current = true;
      setSelectedPSN((_cameras$16 = cameras[3]) === null || _cameras$16 === void 0 ? void 0 : _cameras$16.psn);
    }
  }, playerMarkup4)))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx10["default"])(classes.mapDiv, (_clsx9 = {}, _defineProperty(_clsx9, classes.mapDivNotification, notification), _defineProperty(_clsx9, classes.mapDivMapBox, noMargin), _defineProperty(_clsx9, classes.mapDivApp, app), _defineProperty(_clsx9, classes.mapDivAppNoBottom, noBottom), _clsx9))
  }, ((videoSettings === null || videoSettings === void 0 ? void 0 : videoSettings["UseGpsInfo"]) === "1" || isPublic) && /*#__PURE__*/_react["default"].createElement(_MapboxLocationMap.MapboxLocationMap, {
    psn: currentCam === null || currentCam === void 0 ? void 0 : currentCam.psn,
    fullscreenIcon: true,
    liveView: true
    // app={app}
    ,
    speedUnit: speedUnit,
    cameraState: cameraState,
    pushEventState: pushEventState,
    userState: userState,
    locationState: locationState,
    themeState: themeState,
    geofenceState: geofenceState,
    groupState: groupState,
    t: t,
    onSetFullscreen: onSetFullScreen,
    onExitFullScreen: onExitFullScreen
  }), (videoSettings === null || videoSettings === void 0 ? void 0 : videoSettings["UseGpsInfo"]) === "0" && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.noGpsDiv
  }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
    category: "Default",
    variant: "BodyBold",
    htmlColor: _pittaModules.LightColors.primary["0"]
  }, t("GPS Location recording off")))), mobile && !isPublic && /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.MobileMenu, {
    open: openMenu,
    onClose: function onClose() {
      return setOpenMenu(false);
    },
    paperClasses: color === "dark" ? classes.darkMobileMenu : ""
  }, directionMenuMarkup), !mobile && !isPublic && /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Menu, {
    open: openMenu,
    anchorEl: menuAnchorRef.current,
    onClickAway: function onClickAway() {
      return setOpenMenu(false);
    },
    placement: "bottom-end"
  }, directionMenuMarkup), /*#__PURE__*/_react["default"].createElement(_Drawer["default"], {
    anchor: "right",
    open: openCameraMenu
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.cameraDrawerDiv
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.drawerHeaderDiv
  }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
    category: "Default",
    variant: "H6"
  }, t("Add camera to_")), /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.IconButton, {
    className: classes.iconBtn,
    onClick: function onClick() {
      setOpenCameraMenu(false);
      setSearchKey("");
    }
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.cameraDiv
  }, /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    dense: true,
    placeholder: t("search"),
    startIcon: /*#__PURE__*/_react["default"].createElement(_Search["default"], {
      className: classes.searchIcon
    }),
    onChange: function onChange(e) {
      return setSearchKey(e.target.value);
    },
    value: searchKey,
    disabled: candidateCams.length === 0
  }), filteredCameras.length === 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.emptyDiv
  }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.EmptyItems, {
    variant: "small",
    mode: "liveView",
    noCamTextClassName: (0, _clsx10["default"])(mobile && classes.noCamText)
  })), filteredCameras.length > 0 && /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
    className: classes.camListDiv
  }, /*#__PURE__*/_react["default"].createElement(_RadioGroup["default"], {
    value: addedCam,
    onChange: function onChange(e) {
      return setAddedCam(e.target.value);
    }
  }, _lodash["default"].chain(cameraList === null || cameraList === void 0 ? void 0 : cameraList.deviceListInfo).groupBy(function (cam) {
    return cam.device.psn;
  }).map(function (cams) {
    return cams[0];
  }).filter(function (cam) {
    return cam.device.reg_category === "cloud";
  }).filter(function (cam) {
    return !_lodash["default"].chain(cameras).map(function (c) {
      return c === null || c === void 0 ? void 0 : c.psn;
    }).includes(cam.device.psn).value();
  }).filter(function (cam) {
    return _lodash["default"].includes(_lodash["default"].map(filteredCameras, function (c) {
      return c === null || c === void 0 ? void 0 : c.device.psn;
    }), cam.device.psn);
  }).map(function (cam) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.camListItem,
      key: cam.device.psn
    }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.RadioButton, {
      disabled: cam.device.active === "off",
      value: cam.device.psn,
      checked: addedCam === cam.device.psn,
      label: /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
        className: classes.camName,
        category: "Default",
        variant: "Body"
      }, cam.device.dev_name),
      onChange: function onChange(e) {
        setAddedCam(e.target.value);
      }
    }), /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
      className: classes.modelName,
      category: "Default",
      variant: "Small",
      htmlColor: _pittaModules.LightColors.primary["2"]
    }, cam.device.model));
  }).value()))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.drawerBtnDiv
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Button, {
    variant: "outlined",
    color: "primary",
    className: classes.cancelBtn,
    onClick: function onClick() {
      setOpenCameraMenu(false);
      setSearchKey("");
    }
  }, t("Cancel")), /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Button, {
    disabled: addedCam === undefined,
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      var cam = _lodash["default"].find(cameraList === null || cameraList === void 0 ? void 0 : cameraList.deviceListInfo, function (c) {
        return c.device.psn === addedCam;
      });
      console.log("add", viewIndx, cam, addedCam);
      if (viewIndx !== undefined && cam) {
        updateCenter.current = true;
        setSelectedPSN(cam.device.psn);
        setCameras(function (c) {
          return (0, _immutabilityHelper["default"])(c, _defineProperty({}, viewIndx, function () {
            return cam.device;
          }));
        });
        setViewIndx(undefined);
        setOpenCameraMenu(false);
        setAddedCam(undefined);
      }
    }
  }, t("Add")))))), /*#__PURE__*/_react["default"].createElement(_LiveViewExceedModal.LiveViewExceedModal, {
    open: openLimitLiveview,
    onClose: function onClose() {
      setOpenLimitLiveview(false);
      // 11862 - 라이브뷰 소진 팝업을 닫은 적이 있다면 다시 열리지 않도록 하기 위함. (Leehj)
      setLiveviewPopupWasClosed(true);
    },
    onClickPositive: function onClickPositive() {
      // setOpenPricing(true);
      onOpenPricingModal();
      setOpenLimitLiveview(false);
      setLiveviewPopupWasClosed(true);
    },
    onClickNegative: function onClickNegative() {
      setOpenLimitLiveview(false);
      setLiveviewPopupWasClosed(true);
    },
    t: t
  }), /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Modal, {
    open: openNoMicPermModal,
    headingIcon: /*#__PURE__*/_react["default"].createElement(_Error["default"], {
      htmlColor: _pittaModules.LightColors.secondary["11"]
    }),
    heading: t("Microphone blocked"),
    content: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
      category: "Default",
      variant: "Body"
    }, t("Enable microphone access_")), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
      category: "Default",
      variant: "Small",
      htmlColor: _pittaModules.LightColors.primary["3"]
    }, "* ", t("You may need to_"))),
    close: true,
    onClose: function onClose() {
      return setOpenNoMicPermModal(false);
    },
    onClickPositive: function onClickPositive() {
      return setOpenNoMicPermModal(false);
    },
    RButton: t("OK")
  }), /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Modal, {
    open: openNoMicPermIOSModal,
    heading: t("Want to use a Voice call?"),
    content: /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: "flex",
        alignItems: "center",
        flexDirection: "column"
      }
    }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
      category: "Default",
      variant: "Body"
    }, t("To use a voice call_")), /*#__PURE__*/_react["default"].createElement("img", {
      src: "/images/ios-mic-perm.png",
      style: {
        width: 270,
        paddingTop: 16,
        paddingBottom: 16
      },
      alt: "No mic permission"
    })),
    close: true,
    onClose: function onClose() {
      return setOpenNoMicPermIOSModal(false);
    },
    onClickPositive: function onClickPositive() {
      return setOpenNoMicPermIOSModal(false);
    },
    contentClassName: classes.iosModalContent,
    RButton: t("OK")
  }));
});
exports.LiveViewPanel = LiveViewPanel;